//any type checked blueice
export class StudentAutocompleteSearchDTO {
    constructor(
        public enrolledClassId: string,
        public gradeLevelId?: string,
        public text?: string,
        public schoolId?: string,
        public courseIds?: string[],
        public showInActiveStudent?: boolean
    ) {
        this.enrolledClassId = enrolledClassId ? enrolledClassId : null;
        this.gradeLevelId = gradeLevelId ? gradeLevelId : null;
        this.text = text ? text : '';
        this.schoolId = schoolId ? schoolId : null;
        this.courseIds = courseIds ? courseIds : [];
        this.showInActiveStudent = showInActiveStudent ? showInActiveStudent : false;
    }
}
